import React from 'react'

import OptionsProp from './OptionsProp'

const ChainStart = (props) => <OptionsProp {...props} />

export default ChainStart
